var wsod_security = {};

(function ($) {
	wsod_security.isNewPage = false;

	wsod_security.elements = {
		securityResults: '#WSOD_FixedIncomeIdeas_SecurityResults',
		pageNav: '#WSOD_FixedIncomeIdeas_PageNav',
		securityTable: '#WSOD_FixedIncomeIdeas_SecurityTable',
		footerF2App: 'FixedIncomeIdeasF2App_Footer'
	};

	wsod_security.init = function () {
		wsod_security.initSecurityNav();
		wsod_security.initTableSorter();

		$(wsod_security.elements.securityResults + ' div.show-expand div.center').click(wsod_security.showMore);
		$(wsod_security.elements.securityResults + ' div.show-expand div.center.show-all').click(wsod_security.showAll);
	};

    wsod_security.initSecurityNav = function () {
		wsod_security.getSecurityNav();

		this.$SecurityNav = wsod_security.getSecurityNav();

		$('li', this.$SecurityNav).bind('click', wsod_security.toggleSecurityType);
	};

    wsod_security.getSecurityContainer = function () {
		if (!this.$SecurityContainer) {
			this.$SecurityContainer = $('div.bufferContent', $('div' + wsod_security.elements.securityTable));
		}

		return this.$SecurityContainer;
	};

    wsod_security.getSecurityNav = function () {
		if (!this.$SecurityNav) {
			this.$SecurityNav = $('div' + wsod_security.elements.pageNav);
		}

		return this.$SecurityNav;
	};

    wsod_security.toggleSecurityType = function (e) {
		// toggle menu link
		this.$SecurityType = wsod_security.getSecurityNav();
		$('li', this.$SecurityType).removeClass('selected');

		var $parent = $(e.target).parent();
		$parent.addClass('selected');

		var section = $parent.attr("section");
		wsod_security.loadSecurityType(null, section);
	};

    wsod_security.loadSecurityType = function (pagingOptions, section, isNewPage) {
		this.isNewPage = isNewPage;

		if (section == null) {
			if ($(wsod_security.elements.pageNav + ' .selected').attr('section') != null) {
				section = $(wsod_security.elements.pageNav + ' .selected').attr('section');
			} else {
				section = "WholesaleOTC";
			}
		}

		var data = {
			rowCount: (pagingOptions) ? pagingOptions.NumPerPage : 20,
			pageRequest: true,
			section: section,
			sort: this.sort,
			sortDir: this.sortDir
		};

		if (this._call)
		{
			try
			{
				this._call.abort();
			}
			catch (e) { }
		}

		wsod.showAjaxLoader(this.getSecurityContainer(), "b");

		this._call = wsod.load(
			data,
			section == "WholesaleOTC" ? "Api/GetWholesaleOTCSecurity" : "Api/GetSecurityType",
			wsod_security.updateSecurityType,
			wsod_security.updateSecurityType,
			this
		);
	};

    wsod_security.updateSecurityType = function (results) {
		wsod_security.getSecurityContainer();
		wsod.hideAjaxLoader(this.$SecurityContainer);

		if (this.isNewPage) {
			this.$SecurityContainer.find("table").remove();
			$(wsod_security.elements.securityResults).prepend(results['htmlTable']);
		}
		else {
			this.$SecurityContainer.html(results['html']);
		}

		$(wsod_security.elements.securityResults + ' div.show-expand div.center').click(wsod_security.showMore);
		this.verifySortDir();
		wsod.resizeParentIframe();

		wsod_security.updateFooterF2Loader();
		wsod_security.initTableSorter();
	};

    wsod_security.viewDividendHistory = function () {
		if (window.gChartEngine) {
			window.gChartEngine.LoadPanel.call(window.gChartEngine, "Dividends");
		}
	};

    wsod_security.initTableSorter = function () {
		var self = this;

		$(wsod_security.elements.securityTable + ' table.sortable th.col-code').unbind("click").click(function () {
			var $el = $(this);
            self.sort = "ASXCode";
			self.checkDir($el);
		});

		$(wsod_security.elements.securityTable + ' table.sortable th.col-NextExDate').unbind("click").click(function () {
			var $el = $(this);
			self.sort = "ExDate";
			self.checkDir($el);
		});

		$(wsod_security.elements.securityTable + ' table.sortable th.col-DivPayDate').unbind("click").click(function () {
			var $el = $(this);
			self.sort = "DividendPayableDate";
			self.checkDir($el);
		});

		$(wsod_security.elements.securityTable + ' table.sortable th.col-NextPayDate').unbind("click").click(function () {
			var $el = $(this);
			self.sort = "InterestPayableDate";
			self.checkDir($el);
		});

		$(wsod_security.elements.securityTable + ' table.sortable th.col-coupon').unbind("click").click(function () {
			var $el = $(this);
			self.sort = "InterestRate";
			self.checkDir($el);
		});

		$(wsod_security.elements.securityTable + ' table.sortable th.col-paymentFreq').unbind("click").click(function () {
			var $el = $(this);
			self.sort = "NumberOfInterestPaymentsPerYear";
			self.checkDir($el);
		});

		$(wsod_security.elements.securityTable + ' table.sortable th.col-maturityDate').unbind("click").click(function () {
			var $el = $(this);
			self.sort = "MaturityDate";
			self.checkDir($el);
		});
	};

    wsod_security.checkDir = function ($el) {
		var self = this;

		if ($el.hasClass("headerSortDown")) {
			self.sortDir = "desc";
		}
		else {
			self.sortDir = "asc";
		}

		self.loadSecurityType();
	};

    wsod_security.verifySortDir = function () {
		var sortDir = this.sortDir;
		var sort = this.sort;
		var $sortCode = $(wsod_security.elements.securityTable + ' table.sortable th.col-code');
		var $sortName = $(wsod_security.elements.securityTable + ' table.sortable th.col-name');
		var $sortLastPrice = $(wsod_security.elements.securityTable + ' table.sortable th.col-change');
		var $sortBid = $(wsod_security.elements.securityTable + ' table.sortable th.col-bid');
		var $sortAsk = $(wsod_security.elements.securityTable + ' table.sortable th.col-ask');
		var $sortExDate = $(wsod_security.elements.securityTable + ' table.sortable th.col-NextExDate');
		var $sortDivPayDate = $(wsod_security.elements.securityTable + ' table.sortable th.col-DivPayDate');
		var $sortNextPayDate = $(wsod_security.elements.securityTable + ' table.sortable th.col-NextPayDate');
		var $sortCoupon = $(wsod_security.elements.securityTable + ' table.sortable th.col-coupon');
		var $sortPaymentFreq = $(wsod_security.elements.securityTable + ' table.sortable th.col-paymentFreq');
		var $sortMaturityDate = $(wsod_security.elements.securityTable + ' table.sortable th.col-maturityDate');

		$sortCode.removeClass("headerSortDown");
		$sortName.removeClass("headerSortDown");
		$sortLastPrice.removeClass("headerSortDown");
		$sortBid.removeClass("headerSortDown");
		$sortAsk.removeClass("headerSortDown");
		$sortExDate.removeClass("headerSortDown");
		$sortDivPayDate.removeClass("headerSortDown");
		$sortNextPayDate.removeClass("headerSortDown");
		$sortCoupon.removeClass("headerSortDown");
		$sortPaymentFreq.removeClass("headerSortDown");
		$sortMaturityDate.removeClass("headerSortDown");

		var $sel = null;
		switch (sort) {
			default:
			case "ASXCode": $sel = $sortCode; break;
			case "Name": $sel = $sortName; break;
			case "LastPrice": $sel = $sortLastPrice; break;
			case "Bid": $sel = $sortBid; break;
			case "Ask": $sel = $sortAsk; break;
			case "ExDate": $sel = $sortExDate; break;
			case "DividendPayableDate": $sel = $sortDivPayDate; break;
			case "InterestPayableDate": $sel = $sortNextPayDate; break;
			case "InterestRate": $sel = $sortCoupon; break;
			case "NumberOfInterestPaymentsPerYear": $sel = $sortPaymentFreq; break;
			case "MaturityDate": $sel = $sortMaturityDate; break;
		}

		if (sortDir == "asc") {
			$sel.addClass("headerSortDown");
		} else {
			$sel.removeClass("headerSortDown");
		}
	};

	wsod_security.redirectToTable = function (e) {
		var $el = $(e);
		var path = $el.attr("link");
		var securityTab = { securityTab: $el.text() };
		wsod.post(path, securityTab);
	};

    wsod_security.initTabView = function (securityTab, urlSection) {
		var tabView = "";

		if (urlSection) {
			if (-1 != urlSection.indexOf("HybridSecurities"))
			{
				tabView = "hybridSecurities";
			}
			else if (-1 != urlSection.indexOf("ConvertibleNotes"))
			{
				tabView = "convertibles";
			}
			else if (-1 != urlSection.indexOf("FloatingRateNotes"))
			{
				tabView = "floatingNotes";
			}
			else
			{
				tabView = "corporateBonds";
			}
		}
		else {
			switch (securityTab) {
				default:
				case "Corporate Bonds":
					tabView = "corporateBonds";
					break;
				case "Floating Rate Notes":
					tabView = "floatingNotes";
					break;
				case "Convertible Notes":
					tabView = "convertibles";
					break;
				case "Hybrid Securities":
					tabView = "hybridSecurities";
					break;
			}
		}

		$(wsod_security.elements.pageNav).find('li[section=' + tabView + '] a').click();
	};

    wsod_security.showAll = function (e) {
		var section = "WholesaleOTC";
		var pagingOptions = {
			NumPerPage: 500
		};

		wsod_security.loadSecurityType(pagingOptions, section);
	};

    wsod_security.showMore = function (e) {
		var section = $(wsod_security.elements.pageNav + ' .selected').attr('section');

		var pagingOptions = { NumPerPage: 20 };
		var currentResults = parseInt($('.current-results').text());
		var totalResults = parseInt($('.total-results').text());

		if (currentResults < totalResults) {
			pagingOptions.NumPerPage = currentResults + 20;
		} else if (currentResults == totalResults) {
			pagingOptions.NumPerPage = currentResults - 20;
		}

		wsod_security.loadSecurityType(pagingOptions, section);
	};

    wsod_security.updateFooterF2Loader = function () {
		// if the footer f2 app is not loaded, the loading gif's position is not adjusted which causes a display issue. we need to update it here.
		var footerF2App = $('#' + wsod_security.elements.footerF2App);

        if (footerF2App.html() == "") {
			wsod.showAjaxLoader(footerF2App, "l");
		}
	};

})(jQuery);